export default {
  PageMessage__ARIA_LABEL_CLOSE_BUTTON: "Click close button to dismiss modal message.",
};
